// src/hooks/useDashboardAccess.js
import { useEffect, useState } from "react";
import supabase from "../lib/supabase";

export const useDashboardAccess = (userId, recoveryEmail = null) => {
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noAccess, setNoAccess] = useState(false);

  const schema =
    process.env.REACT_APP_ENV === "prod"
      ? "prod"
      : "public";

  useEffect(() => {
    if (!userId) {
      setDashboards([]);
      setNoAccess(true);
      setLoading(false);
      return;
    }

    let isMounted = true; // ⬅️ prevents updates after unmount

    const fetchAccess = async () => {
      try {
        const query =
          schema === "public"
            ? supabase.from("dashboard_homepage_access")
            : supabase.schema(schema).from("dashboard_homepage_access");

        const { data, error } = await query
          .select("id, public_uuid, dashboard_name, image_url, display_order")
          .eq("user_id", userId)
          .order("display_order", { ascending: true });

        if (!isMounted) return; // ⬅️ stops logs after logout

        if (error) throw error;

        const dashboardsFound = data || [];
        setDashboards(dashboardsFound);
        setNoAccess(dashboardsFound.length === 0);

        if (dashboardsFound.length === 0 && recoveryEmail) {
          console.log(
            `📭 No dashboards found for ${userId}. Recovery email: ${recoveryEmail}`
          );
        }
      } catch (err) {
        if (!isMounted) return; // ⬅️ prevents error logs after logout
        console.error("❌ Dashboard access fetch failed:", err.message);
        setError(err);
        setDashboards([]);
        setNoAccess(true);
      } finally {
        if (isMounted) setLoading(false); // ⬅️ prevents setState after unmount
      }
    };

    fetchAccess();

    return () => {
      isMounted = false; // ⬅️ cleanup on unmount
    };
  }, [userId, recoveryEmail, schema]);

  return { dashboards, loading, error, noAccess };
};